import React from 'react';
import { Link } from 'react-router-dom';
import s from './style.css';
import gs from '../../global.css';
const SideBarItem = ({ icon, title, activeItem, linkTo, setActiveItem }) => {
    const focused = activeItem === linkTo;
    const color = focused ? gs.primaryColor : gs.greyColor;
    return (React.createElement(Link, { onClick: () => setActiveItem(linkTo), to: `/vault/${linkTo}`, className: s.itemContainer, style: { backgroundColor: focused ? 'rgba(0,0,0,0.03)' : undefined } },
        icon,
        React.createElement("p", { className: `${s.title} ${color}`, style: { fontWeight: focused ? 'bold' : undefined } }, title)));
};
export default SideBarItem;
